import { useEffect, useState } from "react";
import { api, type LeaderboardEntry } from "../lib/api";
import { fmtMiles, type Units } from "../lib/format";
import { walkerFromId } from "../../shared/avatars.ts";
import { Portrait } from "./Sprite";

export default function Leaderboard({ units, userId }: { units: Units; userId: string }) {
  const [entries, setEntries] = useState<LeaderboardEntry[]>([]);
  const [me, setMe] = useState<{ rank: number; of: number } | null>(null);
  useEffect(() => {
    api.leaderboard().then((r) => { setEntries(r.entries); setMe(r.me); }).catch(console.error);
  }, []);
  return (
    <div className="card" style={{ marginTop: 10 }}>
      {me ? <div className="sub">You are ranked <b>{me.rank}</b> of {me.of} walkers.</div> : <div className="sub">Turn on "Show me on the leaderboard" to join the ranks.</div>}
      {entries.length === 0 && <div className="sub" style={{ marginTop: 8 }}>No one has set out yet.</div>}
      <ol className="standings">
        {entries.map((e) => (
          <li key={e.user_id} className={e.user_id === userId ? "me" : undefined}>
            <span className="st-rank">{e.rank}</span>
            <Portrait walker={walkerFromId(e.avatar_id)} size={32} />
            <div><div className="st-name">{e.display_name}</div><div className="st-leg">{e.segment_name}</div></div>
            <span className="st-dist">{fmtMiles(e.total_miles, units)}</span>
          </li>
        ))}
      </ol>
    </div>
  );
}
